export default function getParent( element, selector ){
    let immediateParent = element.parentNode;
    let possible = immediateParent.parentNode.querySelectorAll( `*>${ selector }` );
    let result = [...possible].find( item => item === immediateParent );
    let isRoot = immediateParent.nodeName === 'HTML';

    return !possible.length && !result && !isRoot ? getParent( immediateParent, selector ) : !result && isRoot ? null : result ;
};



// WEBPACK FOOTER //
// src/client/helpers/getParent.js